import { Box, Table, TableCell, TableRow, alpha, styled } from '@mui/material';

export const MetadataDetailTableContainer = styled(Box)(() => ({
  width: '100%',
  overflowX: 'auto'
}));

export const MetadataDetailTable = styled(Table)(() => ({
  tableLayout: 'fixed',
  minWidth: '700px'
}));

export const MetadataDetailTableCell = styled(TableCell)(() => ({
  paddingBlock: 0
}));

export const MetadataDetailTableRow = styled(TableRow, { shouldForwardProp: prop => !['isNew'].includes(prop) })(({ theme, isNew }) => ({
  ...(isNew && {
    marginBottom: '2px',
    '& td': {
      backgroundColor: alpha(theme.palette.primary.main, 0.1)
    }
  }),
  height: '60px'
}));
